










import { HasTaskMixin, ResourceLoader } from 'mycorems-app-shared';
import { Account } from '../types';
import repository from './account-repository';

interface Data {
  task: Promise<Account>|undefined,
}

export default HasTaskMixin.extend({
  components: { ResourceLoader },
  model: {
    prop: 'account',
    event: 'loaded',
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    account: Object as () => Account,
  },
  data(): Data {
    return {
      task: undefined,
    };
  },
  watch: {
    accountId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this.task = repository.find(this.accountId);
      this.task.then((account) => {
        this.$emit('loaded', account);
      });
    },
  },
});
